//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFileGuideFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 3.89V21.42L22 19.83V2.31L13 3.89ZM19.5 14.74L15.5 15.45V13.42L19.5 12.71V14.74ZM19.5 10.68L15.5 11.39V9.35L19.5 8.64V10.68Z" fill="currentColor" /><path d="M2 19.84L11 21.43V3.89L2 2.31V19.84Z" fill="currentColor" /></svg>;
}
export default IconFileGuideFill;